import React from 'react';
import { Result, Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { HomeOutlined, LoginOutlined, ArrowLeftOutlined } from '@ant-design/icons';

export function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f0f2f5',
      }}
    >
      <Result
        status="403"
        title="403"
        subTitle="У вас нет доступа к этой странице."
        extra={
          <Space>
            <Button size="middle" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>
              Назад
            </Button>
            <Button size="middle" type="primary" icon={<HomeOutlined />} onClick={() => navigate('/app/search')}>
              На главную
            </Button>
            <Button size="middle" icon={<LoginOutlined />} onClick={() => navigate('/login')}>
              Войти
            </Button>
          </Space>
        }
      />
    </div>
  );
}
